import React from 'react'
import PropTypes from 'prop-types'
import {Box} from '@chakra-ui/react'
import {MinusIcon, PlusIcon} from '../icons'

const CustomAccordionIcon = ({isExpanded}) => {
    return (
        <Box
            transition="transform 0.3s ease"
            transform={isExpanded ? 'rotate(180deg)' : 'rotate(0deg)'}
            display="inline-flex"
            alignItems="center"
            justifyContent="center"
        >
            {isExpanded ? <MinusIcon /> : <PlusIcon />}
        </Box>
    )
}

CustomAccordionIcon.propTypes = {
    isExpanded: PropTypes.any
}
export default CustomAccordionIcon
